import React, { useEffect, useState } from 'react'
import CategoryPage from '../Components/Categorypage/CategoryPage'
import { useLocation } from 'react-router-dom';
import Header from '../Components/Header/Header';

const Category = () => {
  const [cartRefresh, setCartRefresh] = useState(false);

  const refreshCart = () => {
    setCartRefresh((prev) => !prev); // Toggle the state to trigger refresh
  };

  const routePath = useLocation();
  const onTop = () => {
    window.scrollTo(0, 0);
  }
  useEffect(() => {
    onTop()
  }, [routePath]);
  return (
    <>
      <Header cartRefresh={cartRefresh} />
      <CategoryPage onCartUpdate={refreshCart}/>
    </>
  )
}

export default Category;